import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconHeart = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg fill="currentcolor" viewBox="0 0 24 24" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.18 13.083A6.63 6.63 0 0023 8.502a6.63 6.63 0 00-1.82-4.582A6.15 6.15 0 0016.737 2c-1.67 0-3.27.693-4.445 1.92L12 4.226l-.292-.305a6.104 6.104 0 00-8.889 0c-2.425 2.536-2.425 6.628 0 9.163l8.025 8.387a1.6 1.6 0 002.261.05l.051-.05 8.025-8.387ZM19.736 11.7l-1.014 1.06L12 19.786 4.265 11.7c-1.687-1.761-1.687-4.635 0-6.397 1.66-1.737 4.337-1.737 5.998 0l.58.607.05.05a1.6 1.6 0 002.263-.05l.58-.607a4.15 4.15 0 013-1.303c1.121 0 2.2.467 3 1.303A4.63 4.63 0 0121 8.502a4.63 4.63 0 01-1.265 3.198Z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </svg>
  );
};

IconHeart.displayName = "IconHeart";
